ticketDetail = {
    // Tlactiko na spustenie rezimu manualneho zadavania cisla tiketu
    barCodeManual: function() {
        if (more.asideLoading.inProgress) return; // Kontrola ci nie je spustene nejake schvalovanie tiketu
        main.closeDialog();
        setTimeout(function () {
            try {
                BarCodeManualInput();
            } catch (e) {
                console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                return false;
            }
        }, 500);
    },

    // Nacitanie ciaroveho kodu tiketu
    // Nacitanie a zobrazenie tiketu pomocou GUID a citacky
    // Manualnom zadani ticketu
    // Pouziva sa aj pri zobrazeni tickety z mojich tiketov 
    // V historii editacii pre aktualnu verziu ticketu
    // TODO - osetrit nezadane guid
    barCodeTicketInput: function(guid, myTicketsGuid, isRefresh) {
        try {
            // Pokial sa jedna o scrollovanie potiahnutim prsta (moje tikety)
            if (stored.actionsHandling.scrolledByTapAndHold) {
                stored.actionsHandling.scrolledByTapAndHold = false;
                return false;
            }

            if (!(dialog.isOpen("ticketStatusDialog"))) {
                main.closeDialog();
            } else if (stored.OriginalInputTicket) {
                $("body").off("mousedown");
                if (!isRefresh) {
                    ticketDetail.clearTicketStatus();
                }
            }

            // Simulovana akcia uzivatela - v pripade ze sa nejedna o refresh uz pred tym nacitaneho tiketu
            if (!isRefresh) {
                main.userAction(true, true);
                modal.hideTooltip();
            }

            // Nacitanie dat
            if (guid && main.initWebAppCheck()) {
                    if (guid.length === sets.lengthStoredTicketShortID || guid.length === sets.lengthStoredTicketID) {
                        // Restore tiketu
                        stored.OriginalInputGUID = guid;
                        stored.ticketDetailFromMyTickets = false;
                        ticket.retrieveSavedTicket(guid);
                        return true;
                    } else {
                        // Tiket nacitany pomocou skenera, zo sekcie moje tikety alebo sa jedna o refresh zobrazenia
                        if (myTicketsGuid) {
                            // Nacitanie tiketu z mojich tiketov
                            modal.showLoading();
                            stored.ticketDetailFromMyTickets = true;
                            if (!isRefresh) main.createLog(3, "BarCodeInput_MyTickets", "GUID: " + ticket.anonymGuid(guid));
                        } else {
                            stored.ticketDetailFromMyTickets = false;
                        }
                        stored.OriginalInputGUID = guid;
                        service.loadPure("ticketStatus");
                        main.dialogOpen("ticketStatus");
                        if (!rfs.ticketStatusReload) {
                            rfs.ticketStatusReload = setInterval(function () {
                                if (dialog.isOpen("ticketStatusDialog") && stored.OriginalInputGUID) {
                                    ticketDetail.barCodeTicketInput(stored.OriginalInputGUID, stored.ticketDetailFromMyTickets, true);
                                }
                            }, sets.ticketStatusReload);
                            return true;
                        }
                    }
            } else {
                ticketDetail.clearTicketStatus(true);
                main.createLog(2, "BarCodeInput_MissingGUID");
                return false;
            }
        } catch (e) {
            ticketDetail.clearTicketStatus(true);
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.createLog(2, "BarCodeInput_MissingGUID", "ERROR in: ticketDetail.barCodeTicketInput() # " + e);
            return false;
        }
    },

    // Nacitanie a zobrazenie tiketu pomocou ticketCode (len pre zobrazenie, nieje mozne robit akcie nad tiketom)
    // Zobrazenie verzie v editovanom tickete okrem aktualnej verzie
    // Zobrazenie ticketu z bonusov
    ticketCodeTicketInput: function(ticketCode, isEdit) {
        try {
            // Pokial sa jedna o scrollovanie potiahnutim prsta (moje tikety)
            if (stored.actionsHandling.scrolledByTapAndHold) {
                stored.actionsHandling.scrolledByTapAndHold = false;
                return false;
            }
            main.userAction(true, true);
            modal.hideTooltip();
            if (isEdit) {
                // Zrusi pravidelne obnovovanie detailu tiketu
                clearInterval(rfs.ticketStatusReload);
                delete rfs.ticketStatusReload;

                stored.TicketCode = ticketCode;
                $("#ticketStatus .edit-info").addClass("ui-disabled");
                service.loadPure("ticketStatusTicketCode");
            } else {
                if (dialog.isOpen("ticketStatusDialog")) {
                    main.closeDialog();
                    stored.OriginalInputGUID = null;
                }
                // Nacitanie dat
                if (ticketCode && main.initWebAppCheck()) {
                    stored.TicketCode = ticketCode;
                    service.loadPure("ticketStatusTicketCode");
                } else {
                    ticketDetail.clearTicketStatus(true);
                    main.createLog(2, "TicketCodeTicketInput_MissingTicketCode");
                    return false;
                }
            }
        } catch (e) {
            ticketDetail.clearTicketStatus(true);
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.createLog(2, "TicketCodeTicketInput_MissingTicketCode", "ERROR in: ticketDetail.ticketCodeTicketInput() # " + e);
            return false;
        }
    },

    // Zmena poradia zapasov 
    ticketOddsOrderSelect: function(orderBy) {
        try {
            if (!orderBy) {
                stored.ticketOddsOrder? orderBy = stored.ticketOddsOrder: orderBy = profile.TicketStatusOrderDefault;
            }
            if (stored.OriginalInputTicket && orderBy) {
                stored.OriginalInputTicket.Odds.sort(function(oddA, oddB) {
                    if (oddA[orderBy] < oddB[orderBy]) {
                        return -1;
                    } else if (oddA[orderBy] > oddB[orderBy]) {
                        return 1;
                    }
                    return 0;
                });
                // Najskor vyrendruje usporiadane oddy, potom oznaci vybrany order
                $p("#ticketStatus #statusOdds tbody").render(stored.OriginalInputTicket, T.ticketStatusOdds);
                $("#ticketOddsOrderSwitch .ui-btn").removeClass("selected-switch-btn").closest("#" + orderBy + "Switch").addClass("selected-switch-btn");
                // tu sa zoznam oddov v detaile vygeneruje s "lock-btn" z html pri prepnuti filtra poradia
                $("#ticketStatus #statusOdds .lock-btn").removeClass("lock-btn");
                stored.ticketOddsOrder = orderBy;
                return true;
            }
            return false;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na vyrenderovanie podaneho tiketu
    ticketStatusRender: function(data) {
        try {
            if (data && (data = ticketDetail.ticketStatusDataStructure(data))) {
                $("#ticketStatus #statusCombinationsWrap").hide().find("tbody, #ctActualWin").empty();
                // TODO - preco tu bolo toto? 
                // $.mobile.changePage("#ticketStatus", {"role": "dialog"});
                dialog.open({
                    id: "ticketStatusDialog",
                    persistent: true,
                    parseJQM: false,
                    jsEval: false,
                    backdropDismiss: false,
                    onOpen: function() { modal.showLoading(); $p("#ticketStatus #section").render(data, T.ticketStatus);  }, // pre pomalsie nacitanie
                    shown: function() { modal.hideLoading(); },
                    onError: function() { modal.hideLoading(); }                   
                });
                //$p("#ticketStatus #section").render(data, T.ticketStatus);
                ticketDetail.ticketOddsOrderSelect();
                $("#ticketStatus .ui-content").mousedown(function() {
                    main.userAction();
                });
                // Jednoduchy ticket alebo Lottery ticket
                if (data.TYPE === ticket.state.ticketWsTypes.JT) {
                    if (!data.isStoredTicket && data.PlaceBetState !== "edited" || (data.PlaceBetState === "edited" && stored.OriginaIInputCode)) {
                        if (data.PlaceBetState !== "edited" && data.PlaceBetTicketCode && data.Status) { // Potrebne pre oznacenie spravneho tiketu v historii
                            stored.OriginaIInputCode = data.PlaceBetTicketCode;
                        }
                        service.loadPure("ticketStatusHistory");
                    } else {
                        $("#ticketStatus .edit-info, #ticketStatus #ticketOddsOrderSwitch, #ticketStatus .odd-info").removeClass("lock-btn");
                    }
                } else if (data?.IsLotteryTicket === true) {
                    // presunutie pola poplatku do ineho stlpca v hlavicke detailu ticketu
                    $("#statusSummaryLeft #statusFee").detach().prependTo('#statusSummaryMiddle');
                    $("#ticketStatus .odd-info").removeClass("lock-btn");
                } else {
                    $p("#ticketStatus #statusCombinationsWrap").render(data, T.ticketStatusCombi);
                    $("#ticketStatus .ui-dialog-contain").addClass("combi");
                    $("#ticketStatus #statusCombinationsWrap").show();
                    if (profile.FlatCSS) {
                        ticketDetail.ticketStatusBlankRows(".status-combi-table");
                    }
                    $("#ticketStatus .edit-info, #ticketStatus #ticketOddsOrderSwitch, #ticketStatus .odd-info").removeClass("lock-btn");
                }
                if (data.isStoredTicket) {
                    $("#ticketStatus").addClass("ticket-saved");
                    // Ak restornuty tiket nema odd-y
                    if (!data.Odds.length) {
                        $("#ticketStatus #statusValue").text(texts.Tc_ERR_ODDEXP);
                        $("#ticketStatus #statusInfo").show();
                        $("#ticketStatus #statusOdds").hide();
                        $("#ticketStatus .status-buttons .submit-ticket").addClass("ui-disabled").hide();
                    }
                } else {
                    $("#ticketStatus").removeClass("ticket-saved");
                }
                if (data.WinCurrencyFunded === 1) {
                    $("#ticketStatus #statusInfoCurrencyText").show();
                }
                // Ak je na tikete vela oddov tak zobrazi tlacitka na posuvanie
                shared.scrollModule.scrollButtons("ticket-status-odds");
                shared.scrollModule.scrollButtons("ticket-status-combi");
                // Ak je kurz mensi alebo rovny 1 zvyrazni stav oddu ZRUSENY
                if (!data.IsBuyBack) {
                    $("#ticketStatus .is-cancelled").each(function(i, item){
                        $(item).find(".odd-state").removeClass().addClass("odd-state odd-status-C")
                        .find(".state").text(texts["OddStatus_S"]);
                    });
                }
                if (!data.IsPayable) $("#statusExpirationDate").hide();
                if (data.graphData && data.graphData.countgraphdata) {
                    data.graphData.countgraphdata.forEach(function(onePiece, c) {
                        if (data.graphData.countgraphdata[c + 1]) {
                          data.graphData.countgraphdata[c].middleAngle = data.graphData.countgraphdata[c].degStart + (((data.graphData.countgraphdata[c + 1].degStart - data.graphData.countgraphdata[c].degStart) / 2));
                        } else {
                          data.graphData.countgraphdata[c].middleAngle = data.graphData.countgraphdata[c].degStart + (((360 - data.graphData.countgraphdata[c].degStart) / 2));
                        }
                        ticketDetail.renderOddsStatusBadge(onePiece.name, data.graphData.countgraphdata[c], 50, 50);
                    });
                }
            } else {
                // Pri zadani nespravneho GUID tiketu vypise varovnu hlasku
                ticketDetail.barCodeTicketInput();
                modal.showErrObj(1, 5, {err1: texts.TicketErr10, errType: "TicketErr10"});
            }
            if (stored.ticketDetailFromMyTickets) modal.hideLoading();
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            if (stored.ticketDetailFromMyTickets) modal.hideLoading();
            main.closeDialog();
            return false;
        }
    },

    // Funkcia na render historie editcie tiketu
    ticketStatusHistoryRender: function(data) {
        try {
            if (stored.OriginalInputTicket && data && data.length) {
                // Zoradi tikety od najnovsieho po najstarsi
                data.sort(function(etA, etB) {
                    if (etA.EditVersion < etB.EditVersion) {
                        return 1;
                    } else if (etA.EditVersion > etB.EditVersion) {
                        return -1;
                    }
                    return 0;
                });
                $("#ticketStatus #statusEditHistoryWrap").hide().find("tbody").empty();
                $p("#ticketStatus #statusEditHistoryWrap").render(data, T.ticketStatusEditHistory);
                $("#ticketStatus #statusEditHistoryWrap").show();
                $("#ticketStatus .ui-dialog-contain").addClass("edit-history");
                ticketDetail.ticketStatusBlankRows(".status-edit-table");
                $("#ticketStatus .edit-info, #ticketStatus #ticketOddsOrderSwitch, #ticketStatus .odd-info").removeClass("lock-btn");
                return true;
            } else {
                $("#ticketStatus #statusEditHistoryWrap").hide().find("tbody").empty();
                $("#ticketStatus .ui-dialog-contain").removeClass("edit-history");
                $("#ticketStatus #ticketOddsOrderSwitch, #ticketStatus .odd-info").removeClass("lock-btn");
                return false;
            }
        } catch (e) {
            $("#ticketStatus #statusEditHistoryWrap").hide().find("tbody").empty();
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na doplnenie prazdnych riadkov - roztiahnutie okna (historia editacii, kombinacie pri rozpisovom tikete)
    ticketStatusBlankRows: function(tableClass) {
        try {
            var i = 0, rowHeight = 40;
            var section = $("#ticketStatus #section");
            var tableRaw = $("#ticketStatus " + tableClass);
            var tableTbody = tableRaw.find("tbody");
            while (i < 14) {
                if ((tableRaw.height() + rowHeight) <= (section.height() - 44)) {
                    tableTbody.append('<tr class="combinations-blank"><td colspan="4" class="blank-cell">&nbsp;</td></tr>');
                    i++;
                } else {
                    break;
                }
            }
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia upravi data pre detail tiketu
    ticketStatusDataStructure: function(data) {
        try {
            if (data.TYPE !== ticket.state.ticketWsTypes.JT) {
                data.Odds = data.Odds.sort(function (a, b) {
                    return a.Group.localeCompare(b.Group);
                });
            }
            data.winCount = data.lostCount = data.pendCount = 0;
            data.graphdata = new Object(
                countgraphdata = new Array()
            );
            data.Odds.map(function(odd, o) {
                var dateSplitted = odd.DATE.split(".");
                var yearDate = dateSplitted.pop();
                dateSplitted = dateSplitted.concat(yearDate.split(" "));
                yearDate = dateSplitted[3].split(":");
                odd.parsedDate = new Date(dateSplitted[2], dateSplitted[1] -1, dateSplitted[0], yearDate[0], yearDate[1]);
                odd.originalOrder = o;
                if (odd.IsWinning === "Y" || odd.IsWinning === "BB") {
                    // Vyherne oddy, odkupene oddy
                    data.winCount++;
                } else if (odd.IsWinning === "N") {
                    data.lostCount++;
                } else {
                    data.pendCount++;
                }
            });
            return data;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na stopnutie kontroly odpredaja tiketu
    stopTicketRedeem: function(keepValue) {
        try {
            clearTimeout(rfs.redeemCheck);
            rfs.redeemCheck = null;
            if (!keepValue) stored.BuyBackValue = stored.AutoBuyBackValue = null;
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na zistenie obmedzeni pre zobrazenie tlacitok odkupu, kompenzacie
    hasRestriction: function(subject) {
        try {
            switch (subject) {
                case "redeem": {
                    if (profile.Redeem.CheckPlayerVerified) {
                        if (profile.Redeem.CheckPlayer && (!stored.OriginalInputTicket.PlayerID || !stored.OriginalInputTicket.PlayerCardVerified)) {
                            return true;
                        }
                    }
                }
                break;
            }
            return false;
        } catch (e) {
            return true;
        }
    },

    // Funkcia na kontrolu naroku na odpredaj tiketu
    ticketRedeem: function(autoCheck) {
        try {
            if (profile.RedeemTicket && stored.OriginalInputTicket && stored.OriginalInputTicket.PlaceBetID && !["closed", "edited"].includes(stored.OriginalInputTicket.PlaceBetState) && stored.OriginalInputTicket.IsBuyBackAvailable) {
                modal.showLoading();
                var requestUrl;
                $.getJSON(requestUrl = url.ticket + "ticket/" + stored.OriginalInputTicket.PlaceBetID + "/buybackvalueext")
                    .done(function (data) {
                        if (data === Object(data) && !data.ErrorMessage) {
                            if (!profile.Redeem.CheckPlayer || stored.OriginalInputTicket.PlayerID) {
                                // Nekontroluje stav prihlasenia playera || tiket bol podany pod playerom
                                if (data.BuyBackValue >= 0) {
                                    stored.BuyBackDelay = data.BuyBackDelayMs;
                                    stored.BuyBackValue = data.BuyBackValue;
                                    stored.AutoBuyBackValue = data.AutoBuyBackValue;
                                    // Nastavenie hornej hranice odkupovej hodnoty
                                    $("#ticketStatus #autoRedeemTooltip #buyBackLimitUpper").text(shared.floor2(stored.OriginalInputTicket.OverallPotWin, 1) + " " + profile.Currency);

                                    $("#ticketStatus #ticketRedeemAcceptCheckbox").removeClass("ui-disabled").show();
                                    ticketDetail.ticketRedeemCheck(stored.BuyBackValue, stored.AutoBuyBackValue, data.IsBuyBack);
                                } else {
                                    // Nieje mozne odkupit tiket - zatvori okna manualneho aj automatickeho odkupu
                                    ticketDetail.ticketManualRedeemSettingsModal(false, true);
                                    // Skryje tlacidla manualneho a automatickeho odkupu tiketu
                                    $("#ticketStatus .status-buttons .btn-ticket-redeem")
                                    .removeClass("redeem-active").addClass("ui-disabled").hide();

                                    $("#ticketStatus .status-buttons .btn-auto-redeem")
                                    .removeClass("redeem-active").addClass("ui-disabled").hide();
                                }
                            } else {
                                stored.BuyBackDelay = 0;
                                // Disabluje tlacidla odkupu a automatickeho odkupu tiketu, upravi text
                                $("#ticketStatus .status-buttons .ticket-redeem-confirm, #ticketStatus .status-buttons .btn-auto-redeem")
                                .removeClass("redeem-active").addClass("ui-disabled").show();
                                $("#ticketStatus .status-buttons .btn-ticket-redeem").find(".ui-btn-text").text(texts.StatusTicketRedeemPrice + " " + ((data.BuyBackValue > 0)? data.BuyBackValue: 0) + " " + profile.Currency);

                                $("#ticketStatus #ticketRedeemAcceptCheckbox").hide();
                                // Skryje okno automatickeho odkupu
                                ticketDetail.ticketAutoRedeemSettingsModal(false, false);

                                ticketDetail.stopTicketRedeem();
                            }

                            if (ticketDetail.hasRestriction("redeem")) {
                                // Dodatocna kontrola dalsich obmedzeni
                                $("#ticketStatus .status-buttons .ticket-redeem-before-confirm, #ticketStatus .status-buttons .btn-auto-redeem").addClass("ui-disabled").show();
                                // Zobrazi (pod tlacitkom) Predaj tiketu je možný len v prípade, že tiket bol stavený cez vernostnú kartu.
                                $('#ticketStatus .status-buttons #buyBackWarning').show();
                            }
                        } else {
                            stored.BuyBackDelay = 0;
                            // Zatvori okna manualneho aj automatickeho odkupu
                            ticketDetail.ticketAutoRedeemSettingsModal(false, true);
                            // Skryje tlacidla manualneho a autoamtickeho odkupu tiketu
                            $("#ticketStatus .status-buttons .btn-ticket-redeem")
                            .removeClass("redeem-active").addClass("ui-disabled").hide();

                            $("#ticketStatus .status-buttons .ticket-auto-redeem-settings")
                            .removeClass("redeem-active").addClass("ui-disabled").hide();
                        }
                        return data.BuyBackValue;
                    })
                    .fail(function (jqXHR) {
                        jqXHR.requestUrl = requestUrl;
                        $("#ticketStatus .status-buttons .ticket-redeem-confirm").addClass("ui-disabled");
                        main.createLog(2, "CentralTicketBuybackValue_Failed", "GUID: " + ticket.anonymGuid(stored.GUID) + " # AJAX FAILED: " + JSON.stringify(jqXHR));
                        return false;
                    })
                    .always(function () {
                        modal.hideLoading();
                        if (autoCheck && !stored.PlayerID && (!profile.Redeem.CheckPlayer || stored.OriginalInputTicket.PlayerID)) {
                            // Ak sa jedna o autoCheck, neprihlaseneho hraca a je mozny odkup tak pravidelne kontroluje odkupovu hodnotu
                            // Odkupova hodnota pre prihlaseneho hraca sa ziskava cez signalR
                            rfs.redeemCheck = setTimeout(function () {
                                ticketDetail.ticketRedeem(true);
                            }, sets.deltaTimeLive);
                        }
                    });
            } else {
                ticketDetail.stopTicketRedeem();
                return false;
            }

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.createLog(2, "CentralTicketBuybackValue_Failed", "GUID: " + stored.GUID);
            return false;
        }
    },

    // Funkcia na potvrdenie odpredaju tiketu
    ticketRedeemConfirm: function() {
        try {
            main.userAction();
            if (profile.RedeemTicket && stored.OriginalInputGUID && stored.SBID) {
                modal.showLoading(stored.BuyBackDelay / 1000);
                ticketDetail.stopTicketRedeem(true);
                var requestUrl, bbValue = 0;
                if ($("#ticketStatus #acceptRedeemChanges").attr("checked") !== "checked") {
                    // Neakceptuje zmeny odkupovej hodnoty
                    bbValue = stored.BuyBackValue;
                }
                $("#ticketStatus .status-buttons .btn-ticket-redeem, #ticketStatus #ticketRedeemAcceptCheckbox").addClass("ui-disabled");
                requestUrl = url.ticket + "ticket/" + stored.OriginalInputGUID + "/executebuybacksb/value/" + bbValue + "/onsportbox/" + stored.SBID;
                $.ajax({
                    type: "GET",
                    url: requestUrl,
                    dataType: "json",
                    timeout: sets.submitTimeout + stored.BuyBackDelay,
                    async: true
                })
                    .done(function (data) {
                        if (data === Object(data) && data.BuyBackValue && !data.ErrorMessage) {
                            main.createLog(3, "CentralTicketBuybackExecute", "GUID: " + ticket.anonymGuid(stored.OriginalInputGUID) + " # LAST VALUE: " + stored.BuyBackValue + " # CONFIRMED VALUE: " + data.BuyBackValue);
                            if (!(stored.PlayerID && (stored.PlayerID === stored.OriginalInputTicket?.PlayerID) && connection && signalR && (connection.state === signalR.HubConnectionState.Connected))) {
                                // V pripade neprihlaseneho hraca si vyziada tiket zo serveru, inak sa spolieha na signalR
                                service.loadPure('ticketStatus');
                            }
                            stored.BuyBackValue = stored.AutoBuyBackValue = stored.BuyBackDelay = null;
                            return true;
                        } else {
                            main.createLog(2, "CentralTicketBuybackExecute_ERROR", "GUID: " + ticket.anonymGuid(stored.OriginalInputGUID) + " # LAST VALUE: " + data.BuyBackValue + " # ACTUAL VALUE: " + bbValue + " # ERROR: " + data.ErrorMessage);
                            modal.showErrObj(2, 5, {err1: texts.StatusTicketRedeem, err2: texts.StatusTicketRedeemNotAccepted, errType: "default"});
                            $("#ticketStatus .status-buttons .btn-ticket-redeem, #ticketStatus #ticketRedeemAcceptCheckbox").addClass("ui-disabled");
                            ticketDetail.ticketRedeem(true);
                            return false;
                        }
                    })
                    .fail(function (jqXHR) {
                        jqXHR.requestUrl = requestUrl;
                        main.createLog(2, "CentralTicketBuybackExecute_Failed", "GUID: " + ticket.anonymGuid(stored.OriginalInputGUID) + " # AJAX FAILED: " + JSON.stringify(jqXHR));
                        $("#ticketStatus .status-buttons .btn-ticket-redeem, #ticketStatus #ticketRedeemAcceptCheckbox").addClass("ui-disabled");
                        ticketDetail.ticketRedeem(true);
                        return false;
                    })
                    .always(function () {
                        modal.hideLoading();
                    });
            } else {
                ticketDetail.stopTicketRedeem();
                main.createLog(2, "BuybackSet_Failed", "GUID: " + ticket.anonymGuid(stored.OriginalInputGUID) + " SBID: " + stored.SBID);
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.createLog(2, "CentralTicketBuybackExecute_Failed", "GUID: " + ticket.anonymGuid(stored.OriginalInputGUID));
            $("#ticketStatus .status-buttons .btn-ticket-redeem, #ticketStatus #ticketRedeemAcceptCheckbox").removeClass("ui-disabled");
            modal.hideLoading();
            ticketDetail.ticketRedeem(true);
            return false;
        }
    },

    // Funkcia sluzi na check/uncheck checkboxu v okne ticket statusu pri manualnom odkupe tiketu (checkbox akceptacie zmien odkupovej hodnoty tiketu)
    toggleAcceptRedeemChanges: function() {
        try {
            var ticketStatusAcceptChangesCheckbox = $("#ticketStatus #acceptRedeemChanges");
            // Uzivatelska zmena akceptacie zmien odkupovej hodnoty
            if ((ticketStatusAcceptChangesCheckbox).attr("checked")) {
                // Neakceptovanie zmien odkupovej hodnoty
                ticketStatusAcceptChangesCheckbox.attr("checked", false);
            } else {
                // Akceptovanie zmien odkupovej hodnoty tiketu
                ticketStatusAcceptChangesCheckbox.attr("checked", true);
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
        }
    },

    // Funkcia na prisposobenie zobrazenia pre manualny a automaticky odkupu tiketu
    ticketRedeemCheck: function(bbValue, autoBBValue, isBuyBack) {
        try {
            if (isBuyBack) {
                // Doslo k odkupeniu tiketu, nejedna sa o zobrazenie z mojich tiketov
                ticketDetail.barCodeTicketInput(stored.OriginalInputGUID, false, true);
                // Ak su moje tikety aktivne tak ich nanovo stiahne inak vymaze chache
                if (ticket.state.getState().actualTab === ticket.state.ticketTabs.MT) {
                    player.playerTickets.myTicketsFilter(false, true);
                } else {
                    delete cache.MyTickets;
                }
                return true;
            } else if (bbValue >= 0) {
                // Dostupny odkup tiketu
                // Skryje informacie zobrazujuce sa pocas aktivneho automatickeho odkupu
                $("#ticketStatus #autoRedeemTooltip #ticketAutoRedeemSet").hide();
                if (bbValue) {
                    // Dostupny manualny odkup tiketu
                    stored.MinAutoBuyBackValue = stored.BuyBackValue;

                    $("#ticketStatus .status-buttons .btn-ticket-redeem").removeClass("ui-disabled").addClass("redeem-active").show()
                    .find(".ui-btn-text").text(texts.StatusTicketRedeemPrice + " " + shared.floor2(bbValue, 1) + " " + profile.Currency);
                } else {
                    // Nedostupny manualny odkup tiketu bbValue = 0
                    stored.MinAutoBuyBackValue = stored.OriginalInputTicket.OverallTotalBet;

                    // Zatvori okno manualneho odkupu
                    ticketDetail.ticketManualRedeemSettingsModal(false, false);
                    $("#ticketStatus .status-buttons .btn-ticket-redeem")
                    .removeClass("redeem-active").addClass("ui-disabled").hide();

                    if (profile.Redeem.TicketAuto && autoBBValue >= 0) {

                        $("#ticketStatus .status-buttons .ticket-auto-redeem-settings").removeClass("ui-disabled").show();
                    }
                    }
                    $("#ticketStatus #autoRedeemTooltip #buyBackLimitLower").text(shared.floor2(stored.MinAutoBuyBackValue, 1) + " " + profile.Currency);
                    $("#ticketStatus .status-buttons .ticket-auto-redeem-settings .ui-btn-text").text(texts.StatusAutoRedeem);

                if (profile.Redeem.TicketAuto) {
                    if (autoBBValue) {
                        // Nedostupny alebo nastaveny automaticky odkup - skryje predodkupove informacie a kalkulacku
                        $("#ticketStatus #autoRedeemTooltip #autoBBInfoWrapper, #ticketStatus #autoRedeemTooltip #autoBBCalc").hide();

                    if (autoBBValue > 0) {
                            // Nastavena odkupova hodnota -zobrazi button nastavenia automatickeho odkupu
                            $("#ticketStatus .status-buttons .ticket-auto-redeem-settings .ui-btn-text").text(texts.StatusAutoRedeemShortcut + " - " + shared.floor2(autoBBValue, 1) + " " + profile.Currency);
                            $("#ticketStatus .status-buttons .ticket-auto-redeem-settings").removeClass("ui-disabled").addClass("redeem-active").show();
                            // Zobrazi informacie ohladom nastavenej odkupovej hodnoty
                            $("#ticketStatus #autoRedeemTooltip #ticketAutoRedeemSet").show();
                            // Zobrazi hodnotu na ktoru bol odkup nastaveny
                            $("#ticketStatus #autoRedeemTooltip #ticketAutoRedeemValue").removeClass("ui-disabled").text(shared.floor2(autoBBValue, 1) + " " + profile.Currency);
                            $("#ticketStatus .status-buttons .ticket-auto-redeem-stop").removeClass("ui-disabled");
                
                            stored.AutoBuyBackSet = true;
                    } else {
                        // Nedostupny automaticky odkup - zatvori okno automatickeho odkupu
                        ticketDetail.ticketAutoRedeemSettingsModal(false, false);
                
                        $("#ticketStatus .status-buttons .ticket-auto-redeem-settings").addClass("ui-disabled").hide();
                    }
                } else {
                        // Dostupny automaticky odkup, zatial nenastaveny
                        $("#ticketStatus .status-buttons .ticket-auto-redeem-settings").removeClass("ui-disabled redeem-active").show();
                        ticketDetail.assignBuybackValue(true);
                        // Zobrazi predodkupove informacie a kalkulacku
                        $("#ticketStatus #autoRedeemTooltip #autoBBInfoWrapper, #ticketStatus #autoRedeemTooltip #autoBBCalc").show();
                    }
                }
                return true;
            } else {
                // Nedostupny manualny ani automaticky odkup
                $("#ticketStatus .status-buttons .btn-ticket-redeem, #ticketStatus .status-buttons .btn-auto-redeem")
                .removeClass("redeem-active").addClass("ui-disabled").hide();

                ticketDetail.stopTicketRedeem();
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.createLog(2, "TicketRedeemCheck_Failed", "GUID: " + ticket.anonymGuid(stored.OriginalInputGUID));
        }
    },

    // Funkcia na nastavenie/zrusenie automatickeho odkupu tiketu
    ticketAutoRedeemSet: function(stopAutoRedeem) {
        try {
            main.userAction();
            if (rfs.bbSetValue) {
                // Prebieha zadavanie odkupovej hodnoty
                return false;
            }
            if (profile.RedeemTicket && stored.OriginalInputGUID && stored.SBID && (stopAutoRedeem || stored.buyBackInputValue)) {
                var autoBBValue = 0;
                modal.showLoading(stored.BuyBackDelay / 1000);
                $("#ticketStatus .status-buttons .btn-ticket-redeem, #ticketStatus #ticketRedeemAcceptCheckbox").addClass("ui-disabled");
                if (!stopAutoRedeem) {
                    autoBBValue = stored.buyBackInputValue;
                }
                var requestUrl;
                requestUrl = url.ticket + "ticket/" + stored.OriginalInputTicket.PlaceBetID + "/autobuyback/" + stored.OriginalInputTicket.PlaceBetTicketCode + "/value/" + autoBBValue;
                $.ajax({
                    type: "GET",
                    url: requestUrl,
                    dataType: "json",
                    timeout: sets.submitTimeout + stored.BuyBackDelay,
                    async: true
                })
                    .done(function (data) {
                        if (data === Object(data) && (data.AutoBuyBackValue > 0) && !data.ErrorMessage) {
                            // Nastavenie automatickej odkupovej hodnoty
                            main.createLog(3, "CentralTicketAutoBuybackExecute", "# PLACEBETID: " + stored.OriginalInputTicket.PlaceBetID + " # TICKETCODE: " + stored.OriginalInputTicket.PlaceBetTicketCode + " # VALUE BEFORE CONFIRM: " + stored.AutoBuyBackValue + " # CONFIRMED VALUE: " + data.AutoBuyBackValue);
                            stored.AutoBuyBackValue = data.AutoBuyBackValue;
                            ticketDetail.ticketRedeemCheck(data.BuyBackValue, data.AutoBuyBackValue, data.IsBuyBack);
                            return true;
                        } else if ((data.AutoBuyBackValue <= 0) && !data.ErrorMessage) {
                             // Zrusenie automatickeho odkupu
                            main.createLog(3, "CentralTicketAutoBuybackCancel", "# PLACEBETID: " + stored.OriginalInputTicket.PlaceBetID + " # TICKETCODE: " + stored.OriginalInputTicket.PlaceBetTicketCode + " # VALUE BEFORE CONFIRM: " + stored.AutoBuyBackValue + " # CONFIRMED VALUE: " + data.AutoBuyBackValue);
                            stored.AutoBuyBackValue = data.AutoBuyBackValue;
                            ticketDetail.ticketAutoRedeemSettingsModal(false, false);
                            modal.showErrObj(2, 5, {err1: texts.StatusAutoRedeemCanceled, errType: "StatusAutoRedeemCanceled"});
                            ticketDetail.ticketRedeemCheck(data.BuyBackValue, data.AutoBuyBackValue, data.IsBuyBack);
                            return true;
                        } else {
                            stored.AutoBuyBackValue = 0;
                            modal.showErrObj(2, 5, {err1: texts.StatusAutoRedeemNotAccepted, errType: "StatusAutoRedeemNotAccepted"});
                            main.createLog(2, "CentralTicketAutoBuybackSet_ERROR", "GUID: " + ticket.anonymGuid(stored.OriginalInputGUID) + " # LAST VALUE: " + autoBBValue + " # ERROR: " + data.ErrorMessage);
                            ticketDetail.ticketRedeem(true);
                            return false;
                        }
                    })
                    .fail(function (jqXHR) {
                        jqXHR.requestUrl = requestUrl;
                        stored.AutoBuyBackValue = 0;
                        main.createLog(2, "CentralTicketAutoBuybackSet_Failed", "GUID: " + ticket.anonymGuid(stored.OriginalInputGUID) + " # AJAX FAILED: " + JSON.stringify(jqXHR));
                        modal.hideLoading();
                        ticketDetail.ticketRedeem(true);
                        return false;
                    })
                    .always(function () {
                        $("#ticketStatus .status-buttons .btn-ticket-redeem, #ticketStatus #ticketRedeemAcceptCheckbox").removeClass("ui-disabled");
                        modal.hideLoading();
                    });
            } else {
                ticketDetail.stopTicketRedeem();
                main.createLog(2, "AutoBuybackSet_Failed", "GUID: " + ticket.anonymGuid(stored.OriginalInputGUID) + " SBID: " + stored.SBID + " stopAutoRedeem: " + stopAutoRedeem + " buyBackInputValue: " + stored.buyBackInputValue);
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.createLog(2, "CentralTicketAutoBuybackSet_Failed", "GUID: " + ticket.anonymGuid(stored.OriginalInputGUID));
            if (stopAutoRedeem) {
                $("#ticketStatus .status-buttons .ticket-auto-redeem-stop").removeClass("ui-disabled");
            } else if (stored.buyBackInputValue > 0) {
                $("#ticketStatus .status-buttons .ticket-auto-redeem-set").removeClass("ui-disabled");
            }
            modal.hideLoading();
            ticketDetail.ticketRedeem(true);
            return false;
        }
    },

    // Funkcia na zopakovanie podaneho tiketu
    ticketRepeat: function(guid) {
        main.lockApp(null, null, null, null);
        // Ak je GUID zadany ako parameter alebo je ulozeny (ticketStatus) tak spravi jeho klon
        if (guid || (guid = stored.OriginalInputGUID)) {
            try {
                // Skryje vsetky tlacitka tooltip okna
                $("#ticketStatus .status-buttons").find("a, #buyBackWarning, #manualRedeemTooltip, #autoRedeemTooltip, #ticketRedeemNotAllowed").addClass("ui-disabled").hide();
                // Vypne dozadovanie info o odkupe tiketu
                ticketDetail.stopTicketRedeem();

                var requestUrl;
                $.getJSON(requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + "/clone/" + guid + "/SBID_" + stored.SBID)
                    .done(function (data) {
                        if (data === Object(data) && data.TYPE) {

                            ticket.state.setState({liveBetDelayMs: data.LiveBetDelayMs, isEditTicket: data.IsEdited, type: data.TYPE});
                            ticket.ticketTypeSwitch(data.TYPE, !ticket.state.isTicketWsType(data.TYPE));

                            if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                                stored.CombiTimerActive = false;
                                stored.BetAll = false;
                                $(".bet-all .ui-btn").removeClass("ui-btn-active");
                                document.querySelector(".deposit-dial__button--all").classList.remove("deposit-dial__button--active");
                                ticket.state.setState({isClonedTicket: true});
                                $("#depositDial #displayDial").find("#lotterySingleStakeValue").removeClass("selected-input");
                                stored.inputElement = $("#depositDial #displayDial").addClass("selected-input");
                            }
                            // Vyrenderovanie a zmena typu tiketu
                            ticket.ticketRender(data);

                            // Nastavi menu za ktoru sa ma podat tiket
                            if (data.WinCurrencyFunded) {
                                ticket.ticketWinCurrencyModule.activate();
                            } else {
                                ticket.ticketWinCurrencyModule.deactivate();
                            }

                            // Ak je balance mensi ako prednastavena hodnota, tak zrusi vysku vkladu
                            if (ticket.balance() < data.OverallTotalBet) ticket.calc("clear");

                            // Prihlasenie uzivatela na tiketovu sluzbu, oneskorenie aby nativeApp stornovala freebet alebo bonifikaciu
                            if (stored.PlayerID) {
                                setTimeout(function () {
                                    if (ticket.ticketWsSetPlayer(stored.PlayerID, true)) {
                                        // Pripad manualne prihlaseneho hraca
                                        ticket.ticket(data, null, true, true);
                                        // Vycisti a zablokuje pristup k mojim tiketom
                                        player.playerTickets.clearMyTickets(true);
                                        // Nastavi view bez playera
                                        events.eventsSignalrModule.setSignalR();
                                    }
                                }, sets.deltaApproval);
                            } else {
                                ticket.checkSum(data);
                                // Zobrazi tlacidlo stavit tiket
                                $("#ticketStatus .status-buttons .submit-ticket").removeClass("ui-disabled").show();
                            }

                            // Zobrazi tlacidlo lock
                            ticket.ticketCombiModule.ctRenderLockButton();

                        } else {
                            main.createLog(2, "CentralTicketClone_Failed", "GUID: " + ticket.anonymGuid(guid) + " # NO DATA -> TICKET RETRIEVE");
                            ticket.ticketWsRetrieve(true);
                        }
                    })
                    .fail(function (jqXHR) {
                        jqXHR.requestUrl = requestUrl;
                        main.createLog(2, "CentralTicketClone_Failed", "GUID: " + ticket.anonymGuid(guid) + " # AJAX FAILED: " + JSON.stringify(jqXHR));

                    })
                    .always(function () {
                        main.unlockApp();
                    });

            } catch (e) {
                console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                main.createLog(2, "CentralTicketClone_Failed", "GUID: " + ticket.anonymGuid(guid));
                main.closeDialog();
                main.unlockApp();
                return false;
            }
        } else {
            main.unlockApp();
            return false;
        }
    },

    // Funckia odstrani vsetky data o zobrazenom tikete
    clearTicketStatus: function(clearHTML) {
        try {
            ticketDetail.stopTicketRedeem();

            stored.OriginalInputGUID = null;
            stored.OriginaIInputCode = null;
            stored.OriginalInputTicket = null;
            stored.TicketCode = null;
            stored.redirectTo = "";

            // Zrusi pravidelne obnovovanie detailu tiketu
            clearInterval(rfs.ticketStatusReload);
            delete rfs.ticketStatusReload;

            // Zrusi watcher pre tiket detail
            clearTimeout(rfs.watcherTicketDetail);
            rfs.watcherTicketDetail = null;

            modal.hideInfoModal();
            modal.hideTooltip();
            $("#ticketStatus").removeClass("ticket-saved");
            if (clearHTML) {
                $("#ticketStatus #closeTicketStatus").addClass("ui-disabled");
                $("#ticketStatus .status-buttons .ticket-redeem-confirm, #ticketStatus .status-buttons .ticket-redeem-before-confirm").find(".ui-btn-text").text(texts.StatusTicketRedeemPrice);
                $("#ticketStatus #section").empty();
                $("#ticketStatus #statusCombinationsWrap, #ticketStatus #statusEditHistoryWrap").hide().find("tbody, #ctActualWin").empty();
                $("#ticketStatus #closeTicketStatus, #ticketStatus #countGraphInfoIcon").removeClass("ui-disabled");
                $("#ticketStatus .ui-dialog-contain").removeClass("combi edit-history");
                $("#ticketStatus .arrows-combi, #ticketStatus #statusDeposit, #ticketStatus #statusInfo, #ticketStatus #statusInfoCurrencyText").hide();
            }
            return true;
        } catch (e) {
            stored.OriginalInputGUID = null;
            stored.OriginaIInputCode = null;
            stored.OriginalInputTicket = null;
            stored.TicketCode = null;
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na obsluhu zadavania hodnoty automatickeho odkupu tiketu
    calcBuyBack: function(value) {
        try {
            switch (value) {
                // Hodnota automatickeho odkupu na desatine miesta
                case "comma":
                    if (stored.buyBackDecimal) {
                        stored.buyBackDecimal = false;
                        $("#calcbuyBackComma .ui-btn").removeClass("ui-btn-active");
                    } else {
                        stored.buyBackCentesimal = false;
                        stored.buyBackDecimal = true;
                        $("#calcbuyBackComma .ui-btn").addClass("ui-btn-active");
                    }
                    break;

                // Zmazat hodnotu automatickeho odkupu
                case "clear":
                    stored.buyBackDecimal = stored.buyBackInputJustSelected = false;
                    stored.buyBackInputValue = 0;
                    $("#buyBackValue").text(shared.floor2(stored.buyBackInputValue, 1) + " " + profile.Currency);
                    $("#ticketStatus .status-buttons .ticket-auto-redeem-set").addClass("ui-disabled");
                    break;

                // Zadat hodnotu
                default:
                    // Pripocitanie za desatinou ciarkou
                    if (stored.buyBackDecimal) {
                        // Stotina
                        if (stored.buyBackCentesimal) {
                            if (stored.buyBackInputJustSelected) {
                                stored.buyBackInputValue = shared.floor2(value / 100);
                                stored.buyBackInputJustSelected = false;
                            } else {
                                stored.buyBackInputValue = shared.floor2(stored.buyBackInputValue + value / 100);
                                stored.buyBackCentesimal = false;
                            }
                        } else {
                            // Desatine miesto
                            if (stored.buyBackInputJustSelected) {
                                stored.buyBackInputValue = shared.floor2(value / 100);
                                stored.buyBackInputJustSelected = false;
                            } else {
                                stored.buyBackInputValue = shared.floor2(parseInt(stored.buyBackInputValue) + value / 10);
                                stored.buyBackCentesimal = true;
                            }
                        }
                    } else {
                        // Pripocitavanie pred desatinou ciarkou
                        if (stored.buyBackInputJustSelected) {
                            stored.buyBackInputValue = shared.floor2(parseInt(value));
                            stored.buyBackInputJustSelected = false;
                        } else {
                            stored.buyBackInputValue = shared.floor2(parseInt(stored.buyBackInputValue) * 9 + stored.buyBackInputValue + value);
                        }
                    }
                    clearTimeout(rfs.bbSetValue);
                    delete rfs.bbSetValue;
                    ticketDetail.assignBuybackValue(false, false);
                    rfs.bbSetValue = setTimeout(function () {
                        clearTimeout(rfs.bbSetValue);
                        delete rfs.bbSetValue;
                        ticketDetail.assignBuybackValue(false, true);
                    }, sets.ctSetBet);
            }
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia kontroluje limity odkupovej hodnoty tiketu a zobrazenie v odkupovej kalkukulacke
    assignBuybackValue: function(bbChanged, isTimerAssigning) {
        try {
            // Kontrola hranic odkupovej hodnoty tiketu
            if (isTimerAssigning && stored.buyBackInputValue && stored.MinAutoBuyBackValue && (stored.buyBackInputValue < stored.MinAutoBuyBackValue)) {
                // Nastavi minimalnu moznu hodnotu automatickeho odkupu a zobrazi error hlasku
                if (!bbChanged) stored.buyBackInputValue = stored.MinAutoBuyBackValue;
                modal.showErrObj(2, 3, {err1: texts.Tc_BB_MIN_AUTO_REDEEM + " " + shared.floor2(stored.MinAutoBuyBackValue, 1) + " " + profile.Currency, errType: "Tc_BB_MIN_AUTO_REDEEM"});
            } else if (stored.buyBackInputValue > (profile.MaxWin - stored.OriginalInputTicket.OverallTotalBet)) {
                // Prekrocena maximalna mozna vyhra
                if (!bbChanged) stored.buyBackInputValue = 0;
                modal.showErrObj(2, 3, {err1: texts.Tc_BB_MAX_AUTO_REDEEM + " " + shared.floor2((profile.MaxWin - stored.OriginalInputTicket.OverallTotalBet), 1) + " " + profile.Currency, errType: "Tc_BB_MAX_AUTO_REDEEM"});
            } else if (stored.buyBackInputValue > stored.OriginalInputTicket.OverallPotWin) {
                // Nastavi maximalny povoleny strop vysky odkupu tiketu a zobrazi error hlasku
                if (!bbChanged) stored.buyBackInputValue = stored.OriginalInputTicket.OverallPotWin;
                modal.showErrObj(2, 3, {err1: texts.Tc_BB_MAX_AUTO_REDEEM + " " + shared.floor2(stored.OriginalInputTicket.OverallPotWin, 1) + " " + profile.Currency, errType: "Tc_BB_MAX_AUTO_REDEEM"});
            }

            if (!bbChanged) main.userAction();
            // Zadanie hodnoty automatickeho odkupu do kalkulacky
            if (stored.buyBackInputValue && (stored.buyBackInputValue > 0) && (stored.buyBackInputValue >= stored.BuyBackValue) && (stored.buyBackInputValue >= stored.MinAutoBuyBackValue)) {
                // Splnene limity odkupovej hodnoty
                $("#ticketStatus .status-buttons .ticket-auto-redeem-set").removeClass("ui-disabled");
            } else {
                $("#ticketStatus .status-buttons .ticket-auto-redeem-set").addClass("ui-disabled");
            }
            $("#ticketStatus #buyBackValue").text(shared.floor2(stored.buyBackInputValue, 1) + " " + profile.Currency);
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Generuje graf v detaile tiketu
    generateCountGraphBG: function(countgraphdata, startDegree) {
        try {
            startDegree = (typeof startDegree !== "undefined") ? startDegree : 0;
            var oneRound = 360;
            var onePart = oneRound / countgraphdata.map(function (color) {
                return color.count;
            }).reduce(function (previous, current) {
                return (previous + current);
            }, 0);

            var gradientContent = "";

            countgraphdata.forEach(function (cData, c) {
                if (c == 0) {
                    countgraphdata[c].degStart = 0;
                } else {
                    gradientContent += ",";
                }
                gradientContent += countgraphdata[c].colorStarts + " " + countgraphdata[c].degStart + "deg";
                if (countgraphdata[c + 1]) {
                    countgraphdata[c + 1].degStart = (onePart * countgraphdata[c].count) + countgraphdata[c].degStart;
                    gradientContent += "," + countgraphdata[c].colorEnds + " " + countgraphdata[c + 1].degStart + "deg";
                } else {
                    gradientContent += "," + countgraphdata[c].colorEnds + " " + oneRound + "deg";
                }
            });
            return {
                countgraphdata: countgraphdata,
                gradientContent: gradientContent
            };

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Toggle pre graf v detaile tiketu
    toggleCountGraphModal: function() {
        try {
            main.userAction();
            if ($("#countGraphModal").is(":visible")) {
                $("#countGraphModal").hide();
            } else {
                $("#countGraphModal").show();
            }
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Renderuje badge v detaile tiketu
    renderOddsStatusBadge: function(element, oddsData, diameter) {
        try {
            $('#' + element + 'Line').css({
                'left': diameter + 'px',
                'top': diameter + 'px',
                'display': 'inline-block',
                'transform': 'rotate(' + (oddsData.middleAngle - 90) + 'deg)',
                'background': oddsData.bubble,
            }).show().find('.badge-count')
                .attr('data-count', oddsData.count)
                .css({
                    'transform': 'rotate(' + -(oddsData.middleAngle - 90) + 'deg)'
                })
                .addClass(oddsData.name);
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Toggle funkcia okna automatickeho odkupu tiketu
    ticketAutoRedeemSettingsModal: function(toggle, closeOther) {
        try {
            if (closeOther) {
                ticketDetail.ticketManualRedeemSettingsModal();
            } else {
                main.userAction();
            }
            // Nastavi nulovu pociatocnu odkupovu hodnotu tiketu
            ticketDetail.calcBuyBack("clear");
            // Skryje informacnu hlasku
            modal.hideInfoModal();

            var buyBackTooltip = $("#autoRedeemTooltip");
            if (toggle) {
                if (buyBackTooltip.is(":visible")) {
                    // Zatvorenie okna automatickeho odkupu
                    ticketDetail.stopTicketRedeem();
                    buyBackTooltip.hide().addClass("ui-disabled");
                } else {
                    ticketDetail.ticketRedeem(true);
                    buyBackTooltip.show().removeClass("ui-disabled");
                }
            } else {
                // Zatvorenie okna automatickeho odkupu
                ticketDetail.stopTicketRedeem();
                buyBackTooltip.hide().addClass("ui-disabled");
            }
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Toggle funkcia okna manualneho odkupu tiketu
    ticketManualRedeemSettingsModal: function(toggle, closeOther) {
        try {
            if (closeOther) {
                ticketDetail.ticketAutoRedeemSettingsModal();
            } else {
                main.userAction();
            }
            // Nastavi akceptaciu zmeny odkupovej hodnoty tiketu (default)
            $("#ticketStatus #acceptRedeemChanges").attr("checked", true);

            var buyBackTooltip = $("#manualRedeemTooltip");
            if (toggle) {
                if (buyBackTooltip.is(":visible")) {
                    // Zatvorenie okna automatickeho odkupu
                    ticketDetail.stopTicketRedeem();
                    buyBackTooltip.hide().addClass("ui-disabled");
                } else {
                    ticketDetail.ticketRedeem(true);
                    buyBackTooltip.show().removeClass("ui-disabled");
                }
            } else {
                // Zatvorenie okna automatickeho odkupu
                ticketDetail.stopTicketRedeem();
                buyBackTooltip.hide().addClass("ui-disabled");
            }
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na vytlacenie tiketu z tiket detailu
    ticketPrint: function() {
        try {
            // OverallTotalBet, SportBoxTicketGUID, Ticket JSON, couponName - nepouziva sa
            main.createLog(3, "TicketPrintFromDetail_Called", "GUID: " + ticket.anonymGuid(stored.OriginalInputTicket.SportBoxTicketGUID));
            ActionTicketPrint(Math.round(stored.OriginalInputTicket.OverallTotalBet * 100), stored.OriginalInputTicket.SportBoxTicketGUID, JSON.stringify(stored.OriginalInputTicket), null);
            main.closeDialog();
            return true;
        } catch (e) {
            main.createLog(2, "TicketPrintFromDetail_Failed", "GUID: " + ticket.anonymGuid(stored.OriginalInputTicket.SportBoxTicketGUID));
            console.error("ERROR catched in function: " + e);
            return false;
        }
    },

    // Volanie na NativeApp pri storne tiketu
    ticketStorno: function() {
        main.lockApp();
        try {
            if (stored.OriginalInputGUID) {
                ActionTicketStornoByClient(stored.OriginalInputGUID, Math.round(stored.OriginalInputTicket.OverallTotalBet * 100), Math.round(stored.OriginalInputTicket.OverallFee * 100));
                // Opatovne nacita moje tikety

            } else {
                main.createLog(2, "StornoTicket_MissingGUID");
            }
            main.closeDialog();
            main.unlockApp();
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.unlockApp();
            return false;
        }
    }
};
